import config from "../config";
// import sceneBuilder from "./scene-builder";
import sceneBuilderSprites from "./scene-builder-sprites";
import { showStaticDevice, setSpriteOnCanvas } from "../common";
import { setSectionNumber } from "./section-indicators";

const deviceCanvas = document.getElementById(
  "device-canvas"
) as HTMLCanvasElement;
const deviceContext = deviceCanvas.getContext("2d");

export default function () {
  const sceneId = "scene-3";
  const targetScene = config[sceneId];

  const tlIntro = gsap.timeline({
    scrollTrigger: {
      id: `${targetScene.id}-intro`,
      trigger: `#${targetScene.id}-intro`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile + 275}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: function () {
        if (config.mobileLayout) {
          return `+=${config.scrollSpanMobile / 2}`;
        }
        return `+=${config.scrollSpan}`;
      },
      pin: true,
      pinSpacing: true,
      onEnter: () => {
        showStaticDevice();
      },
      scrub: true,
      onEnterBack: () => {
        console.log("tlIntro onEnterBack");
        showStaticDevice();
      },
      onLeaveBack: () => {
        console.log("tlIntro onLeaveBack");
        showStaticDevice();
      },
      // markers: true,
    },
  });
  tlIntro.addLabel('start');
  tlIntro.to(
    "#device-canvas-container",
    {
      yPercent: -80,
      opacity: 0,
      duration: 1,
    },
    "start"
  );
  tlIntro.set("#PageContainer", {
    background: "#F1F1F1",
  }, 'start');
  tlIntro.to(
    "#PageContainer",
    {
      background: "#000",
      duration: 1,
    },
    "start"
  );

  const tlPosition = gsap.timeline({
    scrollTrigger: {
      id: `${targetScene.id}-position`,
      trigger: `#${targetScene.id}-position`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinTextOffsetMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: function () {
        if (config.mobileLayout) {
          return `+=${config.scrollSpanMobile / 2}`;
        }
        return `+=${config.scrollSpan}`;
      },
      scrub: true,
      onEnter: function () {
        console.log("tlPosition onEnter");
        setSectionNumber(3);
        setSpriteOnCanvas({
          context: deviceContext,
          targetFrameIndex: 0,
          spriteSettings: targetScene.sprites,
        });
      },
      onEnterBack: () => {
        console.log("tlPosition onEnterBack");
        showStaticDevice();
      },
      onLeaveBack: () => {
        console.log("tlPosition onLeaveBack");
        showStaticDevice();
      },
      // markers: true,
    },
  });
  tlPosition.addLabel("in");
  tlPosition.set(
    "#device-canvas-container",
    {
      yPercent: 50,
    },
    "in"
  );
  tlPosition.to(
    "#device-canvas-container",
    {
      yPercent: 0,
      opacity: 1,
      duration: 1,
      ease: Sine.easeOut,
    },
    "in"
  );

  // sceneBuilder(sceneId);
  sceneBuilderSprites(targetScene);

  const tlEnd = gsap.timeline({
    scrollTrigger: {
      id: `${targetScene.id}-end`,
      trigger: `#${targetScene.id}-end`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinTextOffsetMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: function () {
        if (config.mobileLayout) {
          return `+=${config.scrollSpanMobile / 2}`;
        }
        return `+=${config.scrollSpan}`;
      },
      scrub: true,
      pin: true,
      // markers: true,
      toggleActions: "play complete none none",
      onEnterBack: function () {
        setSectionNumber(3);
        gsap.to("#PageContainer", 1, {
          background: "#000",
        });
        gsap.to(["#scene-3", "#device-canvas-container"], 1, {
          autoAlpha: 1,
          duration: 1,
        });
        if (!config.mobileLayout) {
          gsap.to("#device-canvas-container", 1, {
            left: "35%",
          });
        }
      },
    },
  });
  tlEnd.addLabel("start");
  tlEnd.to(
    ["#scene-3"],
    {
      duration: 1,
      autoAlpha: 0,
    },
    "start"
  );
  tlEnd.to(
    "#device-canvas-container",
    {
      duration: .8,
      autoAlpha: 0,
      yPercent: -140,
      ease: Sine.easeInOut,
    },
    "start"
  );
}
